module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-wrapper",
    class: {
      hideSidebar: !_vm.state.sidebar.opened, hoverSideBar: _vm.state.sidebar.minOpen
    }
  }, [_c('div', {
    staticClass: "side-wrapper",
    class: {
      hover: !_vm.state.sidebar.minOpened, light: _vm.theme == 'light'
    }
  }, [_vm._m(0), _vm._v(" "), _c('nav-bar', {
    staticStyle: {
      "padding-bottom": "80px",
      "color": "#ffffff",
      "margin-top": "80px"
    }
  }, [_c('Menu', {
    attrs: {
      "width": "220",
      "theme": _vm.theme,
      "accordion": true,
      "active-name": _vm.currentPath
    },
    on: {
      "on-select": _vm.selectFn
    }
  }, _vm._l((_vm.menu), function(item, index) {
    return (_vm.permissions) ? _c('div', {
      key: index
    }, [(item.children && item.children.length > 0 && !item.hidden && (item.permission ? _vm.permissions[item.permission] : true)) ? _c('Submenu', {
      attrs: {
        "name": index
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      staticClass: "iconfont ",
      class: item.icon,
      staticStyle: {
        "margin-left": "0px"
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": "-6px"
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))])]), _vm._v(" "), _vm._l((item.children), function(sub, i) {
      return (!sub.hidden && (sub.permission ? _vm.permissions[sub.permission] : true)) ? _c('Menu-item', {
        key: i,
        attrs: {
          "name": sub.path
        }
      }, [_c('img', {
        staticStyle: {
          "margin-left": "0px"
        },
        attrs: {
          "src": _vm.menuDot
        }
      }), _vm._v(" "), _c('span', {
        staticStyle: {
          "margin-left": "0px"
        }
      }, [_vm._v(_vm._s(_vm.$t(sub.name)))])]) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), (item.permission ? _vm.permissions[item.permission] : true) ? _c('div', [(item.children.length == 0 && !item.hidden && item.level != 0) ? _c('Menu-item', {
      key: index,
      attrs: {
        "name": item.path
      }
    }, [_c('i', {
      staticClass: "iconfont ",
      class: item.icon,
      staticStyle: {
        "margin-left": "0px"
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": "-6px"
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(item.name)))])]) : _vm._e()], 1) : _vm._e()], 1) : _vm._e()
  }), 0)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "main-wrapper"
  }, [_c('t-header', {
    staticStyle: {
      "position": "relative",
      "z-index": "100",
      "background-color": "#FFFFFF"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "margin-left": "15px"
    },
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }, [_c('Breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [(_vm.moduleName) ? _c('Breadcrumb-item', {
    staticClass: "menuNav"
  }, [_vm._v("\n            " + _vm._s(_vm.$t(_vm.moduleName)) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('Breadcrumb-item', {
    staticClass: "menuNav"
  }, [(_vm.$t(_vm.state.router.currentPageName) != _vm.$t('yd.menu.home') || _vm.$t(_vm.state.router.currentPageName) != _vm.$t('yd.menu.dashboard')) ? _c('span', [_vm._v("\n            " + _vm._s(_vm.$t(_vm.state.router.currentPageName)) + "\n            ")]) : _c('span', [_vm._v("\n              Unified Management System\n            ")])])], 1)], 1), _vm._v(" "), _c('Dropdown', {
    staticClass: "userBox",
    staticStyle: {
      "margin-right": "-30px"
    },
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('a', {
    staticStyle: {
      "color": "#3A3A3A"
    },
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [(!_vm.avatarUrl) ? _c('Avatar', {
    staticStyle: {
      "vertical-align": "middle",
      "width": "25px",
      "height": "25px",
      "border-radius": "50%"
    },
    attrs: {
      "src": _vm.avatar
    }
  }) : _c('Avatar', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "src": _vm.avatarUrl
    }
  }), _vm._v(" "), (this.userInfo && this.userInfo.nickname) ? _c('div', {
    staticClass: "ellipsis",
    staticStyle: {
      "display": "inline-block",
      "vertical-align": "middle",
      "margin-left": "5px",
      "max-width": "100px"
    }
  }, [_vm._v("\n            " + _vm._s(this.userInfo.orgName) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('img', {
    staticStyle: {
      "margin-right": "15px"
    },
    attrs: {
      "src": _vm.down
    }
  })], 1), _vm._v(" "), _c('Dropdown-menu', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('Dropdown-item', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "src": _vm.versionInfo
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t("yd.function.version")) + _vm._s(_vm.tmsVersion))])]), _vm._v(" "), _c('Dropdown-item', {
    staticStyle: {
      "text-align": "left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.changePic()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "src": _vm.replacePic
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t("yd.function.changePic")))])]), _vm._v(" "), _c('Dropdown-item', {
    staticStyle: {
      "text-align": "left"
    },
    nativeOn: {
      "click": function($event) {
        _vm.changePassModel = true
      }
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "src": _vm.changePwd
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("  " + _vm._s(_vm.$t("yd.function.changePwd")))])]), _vm._v(" "), _c('Dropdown-item', {
    staticStyle: {
      "text-align": "left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "src": _vm.loggou
    }
  }), _vm._v(" "), _c('span', {}, [_vm._v(_vm._s(_vm.$t("yd.function.logout")))])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "userBox",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('Dropdown', [_c('div', {
    staticStyle: {
      "background": "#ffffff",
      "color": "#595959",
      "width": "100px",
      "height": "42px"
    }
  }, [(this.langModel == 'zh-CN') ? _c('span', [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "src": _vm.langList[0].str
    }
  }), _vm._v(" "), _c('span', {}, [_vm._v("  " + _vm._s(_vm.langList[0].lable))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.down
    }
  })]) : _vm._e(), _vm._v(" "), (this.langModel == 'en-US') ? _c('span', [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "src": _vm.langList[1].str
    }
  }), _vm._v(" "), _c('span', {}, [_vm._v("  " + _vm._s(_vm.langList[1].lable))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.down
    }
  })]) : _vm._e()]), _vm._v(" "), _c('DropdownMenu', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('DropdownItem', {
    nativeOn: {
      "click": function($event) {
        return _vm.changeLanguage(_vm.langList[1].value)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "src": _vm.langList[1].str
    }
  }), _vm._v(" "), _c('span', {}, [_vm._v(_vm._s(_vm.langList[1].lable))])]), _vm._v(" "), _c('DropdownItem', {
    nativeOn: {
      "click": function($event) {
        return _vm.changeLanguage(_vm.langList[0].value)
      }
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "src": _vm.langList[0].str
    }
  }), _vm._v(" "), _c('span', {}, [_vm._v(_vm._s(_vm.langList[0].lable))])])], 1)], 1)], 1), _vm._v(" "), (_vm.manage_flag) ? _c('div', {
    staticClass: "userBox",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('a', {
    staticStyle: {
      "color": "#3A3A3A"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.returnManage
    }
  }, [_vm._v(_vm._s(_vm.$t("yd.function.return_manage")))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "userBox",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "main-container"
  }, [_c('container', [(!_vm.$route.meta.nocache) ? _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('keep-alive', [_c('router-view')], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$route.meta.nocache) ? _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.$t('yd.function.changeavatar'),
      "styles": {
        top: '20px'
      },
      "mask-closable": false,
      "width": "500"
    },
    model: {
      value: (_vm.updateAvatar),
      callback: function($$v) {
        _vm.updateAvatar = $$v
      },
      expression: "updateAvatar"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#f60",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "icon-tupian"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('yd.function.changeavatar')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "file-upload"
  }, [(!_vm.avatarUrl) ? _c('Avatar', {
    staticStyle: {
      "vertical-align": "middle",
      "width": "200px",
      "height": "200px",
      "border-radius": "50%",
      "font-size": "182px",
      "line-height": "200px"
    },
    attrs: {
      "icon": "person"
    }
  }) : _c('Avatar', {
    staticStyle: {
      "vertical-align": "middle",
      "width": "200px",
      "height": "200px",
      "border-radius": "50%"
    },
    attrs: {
      "src": _vm.avatarUrl
    }
  }), _vm._v(" "), (!_vm.avatarUrl) ? _c('Avatar', {
    staticStyle: {
      "vertical-align": "bottom"
    },
    attrs: {
      "icon": "person"
    }
  }) : _c('Avatar', {
    staticStyle: {
      "vertical-align": "bottom"
    },
    attrs: {
      "src": _vm.avatarUrl
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Upload', {
    ref: "upload",
    staticStyle: {
      "display": "inline-block",
      "width": "100%"
    },
    attrs: {
      "show-upload-list": true,
      "on-success": _vm.handleSuccess,
      "on-error": _vm.handleError,
      "format": ['jpg', 'jpeg'],
      "max-size": 500,
      "on-format-error": _vm.handleFormatError,
      "on-exceeded-size": _vm.handleMaxSize,
      "before-upload": _vm.handleBeforeUpload,
      "action": _vm.avatarUploadUrl,
      "with-credentials": true,
      "headers": _vm.headers,
      "data": _vm.params
    }
  }, [_c('Button', {
    attrs: {
      "icon": "ios-cloud-upload-outline"
    }
  }, [_vm._v(_vm._s(_vm.$t('yd.form.avatarupload')))])], 1)], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "id": "changePassModel",
      "styles": {
        top: '20%'
      },
      "width": "562",
      "closable": false
    },
    model: {
      value: (_vm.changePassModel),
      callback: function($$v) {
        _vm.changePassModel = $$v
      },
      expression: "changePassModel"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#1d1c1c",
      "text-align": "left"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("yd.function.changepass")))])]), _vm._v(" "), _c('div', [_c('Form', {
    ref: "formItem",
    staticStyle: {
      "width": "90%",
      "margin-top": "-6px",
      "margin-bottom": "34px"
    },
    attrs: {
      "model": _vm.formItem,
      "label-width": 120,
      "rules": _vm.ruleValidate
    }
  }, [_c('FormItem', {
    attrs: {
      "label": _vm.$t('yd.form.oldpassword'),
      "prop": "oldPassword"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "minlength": 8,
      "maxlength": 20
    },
    model: {
      value: (_vm.formItem.oldPassword),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "oldPassword", $$v)
      },
      expression: "formItem.oldPassword"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": _vm.$t('yd.form.newpassword'),
      "prop": "newPassword"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "minlength": 8,
      "placeholder": _vm.$t('yd.error.password_rule_1'),
      "maxlength": 20
    },
    model: {
      value: (_vm.formItem.newPassword),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "newPassword", $$v)
      },
      expression: "formItem.newPassword"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "label": _vm.$t('yd.form.confirmnewpassword'),
      "prop": "confirmPassword"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "minlength": 6,
      "maxlength": 20
    },
    model: {
      value: (_vm.formItem.confirmPassword),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "confirmPassword", $$v)
      },
      expression: "formItem.confirmPassword"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('p', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    nativeOn: {
      "click": function($event) {
        return _vm.closeChangePassModel()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('alert.cancel0')))]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handlePwdModifySubmit(_vm.formItem)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('yd.form.save')))])], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "id": "commonModal",
      "width": "300"
    },
    model: {
      value: (_vm.commonModal),
      callback: function($$v) {
        _vm.commonModal = $$v
      },
      expression: "commonModal"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "font-size": "14px"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v(_vm._s(_vm.common_title))])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.common_content))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "id": "common_btn",
      "type": "primary",
      "long": "",
      "loading": _vm.modal_loading
    },
    on: {
      "click": _vm.conmmon_btn_click
    }
  }, [_vm._v(_vm._s(_vm.common_btn_content))])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-box",
    staticStyle: {
      "height": "50px",
      "line-height": "50px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/headtitle.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cfecc82","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 1406
// module chunks = 28